import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isIterableArray } from '../../../utils/utils'

const CalendarDaySelect = ({ period, day, setDay }: any) => {

    const { t } = useTranslation()

    const getCalendarByMonth = (date: any) => {

        const dayOffset = moment(date, 'DD-MM-YYYY').day() || 7
        const lengthPrev = moment(date, 'DD-MM-YYYY').subtract(1, 'months').daysInMonth()
        const length = moment(date, 'DD-MM-YYYY').daysInMonth()

        const res = []

        // добавляем дни прошлого месяца
        if (dayOffset) {
            for (let i = 0; i < dayOffset - 1; i++) {
                res.unshift({
                    day: String(lengthPrev - i),
                    active: false,
                })
            }
        }

        // добавляем дни текущего месяца
        if (length > 0) {
            for (let i = 1; i <= length; i++) {
                res.push({
                    day: String(i),
                    active: true,
                })
            }
        }

        // добавляем дни будущего месяца
        for (let i = 1; i <= res.length % 7; i++) {
            res.push({
                day: String(i),
                active: false,
            })
        }


        return res
    }

    const [calendarData, setCalendarData] = useState<any>([]);

    useEffect(() => {
        const data = getCalendarByMonth(`01-${period}`)
        setCalendarData(data)
    }, [period]);


    const isToday = (dayP: any) => {
        if (day == dayP) return true
        else return false
    }

    const handleClick = (e: any, day: any) => {
        setDay(day)
    }
    return (
        <div>
            <div className='grow bg-white border-2 border-gray-100 rounded-[16px] p-[6px] mob:p-[12px] tab:p-[24px] lap:px-[32px] lap:py-[24px]'>
                <div className='grid grid-cols-7  gap-[4px] tab:gap-[8px] mb-[36px] text-sm pt-[24px] tab:pt-0'>
                    {[1, 2, 3, 4, 5, 6, 7].map(i => <div key={i} className={`${i > 5 ? 'text-gray-500' : 'text-gray-700'}  `}>{t(`short_day_${i}`)}</div>)}
                </div>
                <div className='grid grid-cols-7  gap-[4px] tab:gap-[8px]'>
                    {
                        calendarData?.length ?
                            calendarData.map((day: any, key: any) => (
                                <div
                                    style={{ transitionProperty: 'none !important' }}
                                    key={key}
                                    className={`
                                                        ${day.active ? 'bg-gray-50 border-gray-100 font-bold text-gray-700' : 'text-gray-500 border-gray-50'}
                                                        border-2 rounded-[8px] text-[12px] mob:text-[14px] tab:text-[16px]
                                                        py-[6px] px-[8px] tab:px-[16px] min-h-[45px] tab:min-h-[64px] flex flex-col justify-between
                                                        transition-none hover:transition-all 
                                                        ${(isToday(day.day) && day.active) ? ' bg-gray-800 text-white ' : ''}
                                                        ${(!isToday(day.day) && day.active) ? 'active:bg-gray-200 lap:hover:bg-gray-100 lap:hover:border-gray-200 lap:hover:cursor-pointer' : ''}
                                                    `}
                                    onClick={(event: any) => {
                                        if (day.active) handleClick(event, day.day)
                                    }}
                                >
                                    {day.day}
                                </div>
                            ))
                            :
                            <div className='min-h-[400px]' />
                    }
                </div>
            </div>
        </div>
    )
}

export default CalendarDaySelect